module.exports = "/static/assets/b43cc43126fe68b9f0be90b67f65c3ec.png";